import React from "react";
import OwlCarousel from "react-owl-carousel";
import "owl.carousel/dist/assets/owl.carousel.css";
import "owl.carousel/dist/assets/owl.theme.default.css";
import { Link } from "react-router-dom";
import Api from '../../services/api';
import { toast } from "react-toastify";
import withRouter from "../../services/withRouter";
import Modal from 'react-bootstrap/Modal';


class SchemeAnnouncements extends React.Component {
    
  
    componentDidMount = async () => {
        window.scrollTo(0, 0);
        this.getSchemeAnnouncements();
    };



    getSchemeAnnouncements = async()=>{
        var response = await Api.GetRequest({}, 'scheme-announcements');
        if(response.status == 200){
            this.setState({'scheme_announcements' : response.scheme_announcements});
        }
        else{
            toast.error("Something went wrong. Please try again later.");
        }
    }
  

    constructor(props) {
        super(props);
        this.state = {
            'scheme_announcements' : [],
            'external_link' : "",
            "show_alert" : false
        };
    }


    showExternalLink = async()=>{
        this.setState({'show_alert' : false})
        window.open(this.state.external_link, "_blank")
    }
    

    render(){

        return(
            <>
                <Modal show={this.state.show_alert} centered >
                    <Modal.Header closeButton>
                    </Modal.Header>

                    <Modal.Body>
                        <p class='text-center'>You are about to proceed to an external website. Click YES to proceed.</p>
                    </Modal.Body>

                    <Modal.Footer>
                        <button className="btn btn_theme btn_md mt-3 py-1" onClick={()=>{this.setState({'show_alert' : false})}}>Close</button>

                        <button className="btn btn_theme btn_md mt-3 py-1" onClick={()=>{this.showExternalLink()}}>Ok</button>
                    </Modal.Footer>
                </Modal>
                
                <div class="m-0 shadow"  style={{'width' : '100vw!important', 'maxWidth' : '100vw!important'}}>
                    <div class="row mx-0">
                        <div class="col-lg-12">
                            <div class="commn_banner_page" style={{'position' : 'relative'}}>
                                <img src="/assets/img/header_banner.png"/>
                                <h2 className="text-center mb-0" style={{'position' : 'absolute', 'top' : '40%', 'left' : '10%', 'color' : '#000000', "textTransform" : "uppercase"}}>Scheme Announcements</h2>
                            </div>
                        </div>
                    </div>
                </div>

                <section id="trending_causes_main" class="section_padding">
                    <div class="container">
                        <div class="row" id="counter">
                            {this.state.scheme_announcements.map((scheme_announcement)=>{
                                return(
                                    <div class="col-lg-3 col-md-4 col-sm-12 col-12">
                                        <div class="case_boxed_wrapper bordered" style={{'border' : '1px solid #000000'}}>
                                            <div class="case_boxed_img">
                                                <a href="javascript:;" onClick={()=>{this.showPortal(scheme_announcement.id)}}>
                                                    <img src={process.env.REACT_APP_SERVER + scheme_announcement.image} alt="img"/>
                                                </a>
                                            </div>
                                            <div class="causes_boxed_text">
                                                <h5 style={{'height' : '43px'}}>
                                                    <a style={{'color' : '#000000'}} href="javascript:;" onClick={()=>{this.showPortal(scheme_announcement.id)}}>{scheme_announcement.title}</a>
                                                </h5>
                                                <a href="javascript:;" onClick={()=>{this.setState({'external_link' : scheme_announcement.link, 'show_alert' : true})}}><button className="btn btn_theme btn_md mt-3 py-1">Click Here</button></a>
                                            </div>
                                        </div>
                                    </div>
                                )
                            })}
                        </div>
                    </div>
                </section>
            </>
        )
    }
}


export default withRouter(SchemeAnnouncements)